import { createContext, useContext } from 'react';

import { FieldMappingGroup } from '@components/text-editors/addons/field-mapping';

import { CreateFormBuilderStoreType } from './create-builder-store';

export type PredefinedOptionsLists = Array<{
  value: string;
  label: string;
  options: Array<{ value: string; label: string }>;
  isHidden: boolean;
}>;
export type FormBuilderContextValue = {
  store: CreateFormBuilderStoreType;
  predefinedOptionsLists: PredefinedOptionsLists;
  variableGroups?: FieldMappingGroup[];
};
export type FormBuilderContextType = FormBuilderContextValue | undefined;

export const FormBuilderContext = createContext<FormBuilderContextType>(undefined);

export const useFormBuilderContext = () => {
  const context = useContext(FormBuilderContext);
  if (!context) throw new Error('Missing FormBuilderContext');

  return context;
};

export const FormBuilderContextProvider = FormBuilderContext.Provider;
